// Si se desea empezar a implementar multi idioma en pentaho con alguna
// variable global o de pentaho se puede asignar valor a esta constante.
// SOLO en los js que tengan los textos separados.
export const IDIOMA = 'ca_ES';
// Constantes utilizadas para definir parámetros de gráficas
export const TOP_LEGEND = '8%';
export const LEFT_GRID = '2.5%';
export const RIGTH_GRID = '5%';
export const BOTTOM_GRID = '18%';
export const TOP_GRID = '20%';
export const TOP_GRID_SIN_LEYENDA = '10%';
export const HEIGH_GRID = '90%';
export const RIGTH_TOOLBOX = '1%';
export const TOP_TOOLBOX = '0%';
export const DEFAULT_NAME_MARGIN_Y = 0;
export const DAY_VALUE = 65;
export const NIGHT_VALUE = 55;
export const COLORS = [
  '#9c89b8',
  '#4ea8de',
  '#05668d',
  '#ffbf69',
  '#e56b6f',
  '#83c5be',
  '#02c39a',
  '#ee9b00',
  '#cdb4db',
  '#ffadad',
  '#ce4257',
  '#b7b7a4',
];
export const DIVSIZE = 33;
export const CENTER_VALENCIA = [39.46975, -0.37739];
